let activated = false;

/**
 * ナビゲーションバーのバーガーメニューを有効化する。
 */
export const activateNavbarBurger = () => {
    if (activated) {
        console.warn("navbar burger is activated twice or more!");
        return;
    }

    try {
        const burgers = document.getElementsByClassName("navbar-burger");

        for (const burger of burgers) {
            if (!(burger instanceof HTMLElement)) {
                continue;
            }

            burger.addEventListener("click", () => {
                const targetId = burger.dataset.target;
                if (targetId) {
                    const targetElem = document.getElementById(targetId);
                    if (targetElem) {
                        burger.classList.toggle("is-active");
                        targetElem.classList.toggle("is-active");
                    }
                }
            });
        }
    } catch (e) {
        console.error(e);
    }

    activated = true;
};
